import React from 'react';
import {Field, reduxForm} from "redux-form";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import {connect} from "react-redux";
import {Box, FormControlLabel, Checkbox} from "@material-ui/core";
// import AllowPaymentField from "../../../reduxFormComponents/AllowPaymentField";
import HereMap from "../../../HereMap";
import {updateHereToken} from "../../../../store/actionCreators";
import useRunOnce from "../../../../hooks/useRunOnce";
import SelectAddress from "../../../reduxFormComponents/SelectAddress";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    fields: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto'
    },
    field: {
        marginBottom: theme.spacing(4),
    },
    disabledArea: {
        filter: 'contrast(0.2) opacity(0.7)',
        pointerEvents: 'none'
    },
    actions: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: theme.spacing(2)
    },
    nextButton: {
        width: theme.bigButtonSize,
        marginLeft: theme.spacing(4)
    }

}));
const MoreDetails = ({handleSubmit, handleBack, editMode, hereToken, updateHereToken}) => {
    const classes = useStyles()
    const {t} = useTranslation();

    useRunOnce(() => {
        updateHereToken()
    })

    return <form onSubmit={handleSubmit} className={classes.root}>
        <Box display={'flex'} justifyContent={'center'} pb={2}>
            {/*<Typography variant={"body2"} gutterBottom>{t('personal_details_explanation')}</Typography>*/}
        </Box>
        <div className={classes.fields}>
            {/* <Field name="allowPayments" className={classes.field} component={AllowPaymentField} editMode={editMode}/> */}
            <Field name="allowMultipleServices" className={classes.field} component={({input, label}) => (
        <FormControlLabel
            control={
                <Checkbox
                color={'primary'}
                    checked={input.value ? true : false}
                    onChange={input.onChange}
                />
            }
            label={t('allow_multiple_services')}
        />
)}/>
            <Field name="address" className={classes.field} component={SelectAddress}
                   type={'text'}
                   label={t('address')}/>
            {hereToken && <Field name="cities" className={classes.field} component={HereMap} hereToken={hereToken}
                   type={'text'}
                   label={t('cities')}/>}
        </div>
        <div className={classes.actions}>
            <Button color="primary" variant="outlined" onClick={handleBack}>
                {t('back')}
            </Button>
            <Button type="submit" color="primary" variant="contained" className={classes.nextButton}>
                {t('next')}
            </Button>
        </div>
    </form>
}
const mapStateToProps = state => ({
    hereToken: state.general.hereToken
})
const mapDispatchToProps = dispatch => ({
    updateHereToken: updateHereToken(dispatch),
})
const ConnectedMoreDetails = connect(mapStateToProps, mapDispatchToProps)(MoreDetails)


export default reduxForm({
    form: 'signupSupplierForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ConnectedMoreDetails);